import "esbuild-css-modules-plugin-ns-css:src/ui/UnusedParameters.module.css";

export default {
  "header": "UnusedParameters-module__header_BZL2TW__0230",
  "hidden": "UnusedParameters-module__hidden_BZL2TW__0230",
  "paramListItem": "UnusedParameters-module__param-list-item_BZL2TW__0230",
  "unusedParameters": "UnusedParameters-module__unused-parameters_BZL2TW__0230"
};
      